import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Check, Heart, MessageCircle } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-white" data-id="element-314" data-mp="4xclyy19imcl">
      <div className="max-w-lg md:max-w-2xl mx-auto" data-id="element-315" data-mp="9u39g6feck81">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white p-8 md:p-12 rounded-3xl border-2 border-[#4CAF50] shadow-lg relative overflow-hidden" data-id="element-316" data-mp="9wphs8a433rb">
          <div className="absolute top-0 left-0 w-full h-2 bg-[#4CAF50]" data-id="element-317" data-mp="skcctjmx6i1b"></div>

          <div className="flex justify-center mb-6" data-id="element-318" data-mp="xjxkcig5nypn">
            <div className="bg-[#E8F5E9] p-5 rounded-full" data-id="element-319" data-mp="xjfh31v2sk88">
              <ShieldCheck className="w-14 h-14 text-[#4CAF50]" data-id="element-320" data-mp="12jjzixfjnp13" />
            </div>
          </div>

          <h2 className="text-2xl md:text-3xl font-black text-gray-900 mb-2 text-center" data-id="element-321" data-mp="17hlh1dxbngag">
            GARANTÍA TOTAL DE 30 DÍAS
          </h2>
          <p className="text-center text-[#4CAF50] font-bold text-sm uppercase tracking-wider mb-8" data-id="element-322" data-mp="25ti3mcw1ccwu">
            Sin riesgo. Sin letra chica. Sin preguntas.
          </p>

          <div className="space-y-5 text-gray-700 text-lg leading-relaxed mb-8" data-id="element-323" data-mp="1vuskyhwbeofj">
            <p data-id="element-324" data-mp="1rsnt9opfg1vj">
              Sabemos lo que es comprar algo online y preguntarte:{' '}
              <em data-id="element-325" data-mp="2oi59gxm1d6bh">"¿Y si no es lo que esperaba?"</em>
            </p>
            <p data-id="element-326" data-mp="2okj0mvdlhydr">
              Por eso te damos <strong data-id="element-327" data-mp="2jjlmquzmbqi2">30 días completos</strong> para explorar
              NutriPeques, probar las recetas, usar el sistema de planificación
              y ver los resultados en tu mesa.
            </p>
            <p data-id="element-328" data-mp="2arjmawpjua7s">
              Si en ese tiempo sentís que no te aportó valor — por el motivo que
              sea — te devolvemos el <strong data-id="element-329" data-mp="379y04ldmufg1">100% de tu inversión</strong>. Sin
              formularios eternos. Sin justificaciones. Sin hacerte sentir mal.
            </p>
            <p className="font-bold text-gray-900" data-id="element-330" data-mp="32gczelknn7d5">
              Un solo mensaje y te devolvemos cada centavo. Así de simple.
            </p>
          </div>

          <div className="bg-[#F1F8E9] rounded-2xl p-6 mb-8 space-y-3" data-id="element-331" data-mp="15ifgqzyuu6ua">
            <p className="font-bold text-gray-900 text-sm uppercase tracking-wider mb-3 flex items-center gap-2" data-id="element-332" data-mp="qvm98gvku5cn">
              <Heart className="w-4 h-4 text-[#4CAF50]" data-id="element-333" data-mp="vsvx3s3bi8yd" />
              ¿Por qué ofrecemos esta garantía?
            </p>
            <div className="space-y-2.5" data-id="element-334" data-mp="hsl5uny3isco">
              <div className="flex items-start gap-2.5" data-id="element-335" data-mp="mszdi4vsc0a6">
                <Check className="w-5 h-5 text-[#4CAF50] shrink-0 mt-0.5" data-id="element-336" data-mp="muk81ui3nj81" />
                <span className="text-gray-700" data-id="element-337" data-mp="7x1i4otoqzz0">
                  Porque <strong data-id="element-338" data-mp="cv35vn223ngt">+3000 mamás</strong> ya lo usan y los
                  resultados hablan solos.
                </span>
              </div>
              <div className="flex items-start gap-2.5" data-id="element-339" data-mp="22bav14x3gybv">
                <Check className="w-5 h-5 text-[#4CAF50] shrink-0 mt-0.5" data-id="element-340" data-mp="278uau99fxj5x" />
                <span className="text-gray-700" data-id="element-341" data-mp="276q83una2q78">
                  Porque sabemos que cuando lo pruebes, no vas a querer
                  soltarlo.
                </span>
              </div>
              <div className="flex items-start gap-2.5" data-id="element-342" data-mp="3mpyyjw9w57ue">
                <Check className="w-5 h-5 text-[#4CAF50] shrink-0 mt-0.5" data-id="element-343" data-mp="5clq4z3l7cfe" />
                <span className="text-gray-700" data-id="element-344" data-mp="l3m2269ovq7">
                  Porque preferimos que entres tranquila, sin presión y sin
                  miedo.
                </span>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-xl p-5 flex items-start gap-4 mb-6" data-id="element-345" data-mp="a9lm2h6q2yss">
            <MessageCircle className="w-8 h-8 text-[#4CAF50] shrink-0 mt-0.5" data-id="element-346" data-mp="oaxxqgeuoe8v" />
            <div data-id="element-347" data-mp="jbbkw82xp00l">
              <p className="text-gray-800 font-bold mb-1" data-id="element-348" data-mp="jatfolyanbgj">¿Cómo funciona?</p>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-349" data-mp="2q1rn1ven49u2">
                Dentro de los 30 días posteriores a tu compra, simplemente
                escribinos un mensaje diciendo que querés tu reembolso. No
                necesitás dar explicaciones. Procesamos la devolución en 24–48
                horas hábiles. Cero drama.
              </p>
            </div>
          </div>

          <p className="text-center text-[#2E7D32] font-black italic text-lg" data-id="element-350" data-mp="2rkricbeq1aah">
            "El riesgo es nuestro. La tranquilidad, tuya."
          </p>
        </motion.div>
      </div>
    </section>;
}